import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const visibleFilter = (source: ReturnType<typeof useDocumentsDataTable>) => {
  const options = [
    {
      label: i18n.t('documents.employee.filters.visible'),
      value: true,
    },
    {
      label: i18n.t('documents.employee.filters.hidden'),
      value: false,
    },
  ]

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Boolean,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'public',
    path: 'published',
    title: i18n.t('documents.employee.filters.visibility'),
  })
}

export default visibleFilter
